import { EventUserEntity } from 'src/store/eventApi';
import { GENDER_FEMALE, GENDER_MALE, GENDER_NON_BINARY } from './genderStyle';

export interface SeatAssignment {
  seat: string;
  index: number;
  gender: number | undefined;
}

const PREFIX_BY_GENDER: Record<number, string> = {
  [GENDER_MALE]: 'M',
  [GENDER_FEMALE]: 'F',
  [GENDER_NON_BINARY]: 'X',
};

const attendeeName = (eu: EventUserEntity) =>
  eu.user?.profile?.name || eu.user?.email || eu.userId;

const sortByName = (a: EventUserEntity, b: EventUserEntity) =>
  attendeeName(a).localeCompare(attendeeName(b), 'zh-Hans-CN', {
    sensitivity: 'base',
    numeric: true,
  });

export const assignSeats = (
  attendees: EventUserEntity[]
): Map<string, SeatAssignment> => {
  const buckets = new Map<string | number, EventUserEntity[]>();
  for (const eu of attendees) {
    const key = eu.user?.profile?.gender ?? '__unknown__';
    const arr = buckets.get(key) ?? [];
    arr.push(eu);
    buckets.set(key, arr);
  }

  const result = new Map<string, SeatAssignment>();
  for (const [key, arr] of buckets.entries()) {
    arr.sort(sortByName);
    const gender = typeof key === 'number' ? key : undefined;
    const prefix =
      typeof gender === 'number' ? PREFIX_BY_GENDER[gender] ?? '' : '';
    arr.forEach((eu, idx) => {
      const num = (idx + 1).toString().padStart(2, '0');
      result.set(eu.userId, {
        seat: `${prefix}${num}`,
        index: idx,
        gender,
      });
    });
  }
  return result;
};

export const genderLabel = (gender: number | undefined): string => {
  if (gender === GENDER_MALE) return '男';
  if (gender === GENDER_FEMALE) return '女';
  if (gender === GENDER_NON_BINARY) return '非二元';
  return '';
};
